import { MessageCircle } from "lucide-react";
import { COMMERCIAL_WHATSAPP_DIGITS, whatsappUrl } from "@/constants/site";
import { usePartner } from "@/context/PartnerContext";

const buildPartnerUrl = (msg) =>
  `https://wa.me/${COMMERCIAL_WHATSAPP_DIGITS}?text=${encodeURIComponent(msg)}`;

export const WhatsAppButton = () => {
  const { config } = usePartner();
  const href = config?.whatsappMessage
    ? buildPartnerUrl(config.whatsappMessage)
    : whatsappUrl();

  return (
    <a
      data-testid="whatsapp-float-btn"
      data-partner={config?.code || ""}
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={
        config?.whatsappMessage
          ? `Contáctanos por WhatsApp — Alianza ${config.name}`
          : "Contáctanos por WhatsApp"
      }
      className="fixed bottom-24 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-brand-whatsapp text-white shadow-lg shadow-brand-whatsapp/40 transition-all hover:scale-110 hover:shadow-xl lg:bottom-6 lg:right-6"
    >
      <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-whatsapp opacity-30" />
      <MessageCircle className="relative h-7 w-7" />
    </a>
  );
};
